import { render, staticRenderFns } from "./AutoBatchRenewalUPPListing.vue?vue&type=template&id=0ddb9979&"
import script from "./AutoBatchRenewalUPPListing.vue?vue&type=script&lang=js&"
export * from "./AutoBatchRenewalUPPListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports